export function parseServerError(message) {
  if (!message) return { code: undefined, message: '' };

  // 1) try JSON (entire message)
  try {
    const obj = JSON.parse(message);
    const code =
      obj?.Code ?? obj?.Status ?? obj?.status ?? obj?.errorCode ?? obj?.error?.code;
    const msg =
      obj?.Message ?? obj?.message ?? obj?.error?.message ?? message;

    if (code) return { code: String(code), message: String(msg) };

    const firstErr = obj?.Message?.Errors?.[0];
    if (firstErr?.Code) return { code: String(firstErr.Code), message: String(firstErr.Message || msg) };
  } catch (_) {}

  // 2) try to extract a JSON object embedded inside text
  const firstBrace = message.indexOf('{');
  const lastBrace = message.lastIndexOf('}');
  if (firstBrace !== -1 && lastBrace > firstBrace) {
    try {
      const embedded = JSON.parse(message.slice(firstBrace, lastBrace + 1));
      const code =
        embedded?.Code ?? embedded?.Status ?? embedded?.status ?? embedded?.errorCode;
      const msg =
        embedded?.Message ?? embedded?.message ?? message;
      if (code) return { code: String(code), message: String(msg) };

      const firstErr = embedded?.Message?.Errors?.[0];
      if (firstErr?.Code) return { code: String(firstErr.Code), message: String(firstErr.Message || msg) };
    } catch (_) {}
  }

  // 3) regex fallbacks
  const patterns = [
    /Error Code (\d+):/i,     // "Error Code 461: ..."
    /"Code"\s*:\s*(\d+)/i,    // ..."Code":461...
    /"Status"\s*:\s*(\d+)/i,  // ..."Status":461...
    /Status Code:\s*(\d+)/i,  // "Status Code: 461"
    /Content:\s*(\d+)/i,      // "Content: 461"
  ];

  for (const re of patterns) {
    const m = message.match(re);
    if (m && m[1]) return { code: m[1], message };
  }

  return { code: undefined, message };
} 